<!-- nav -->
<mat-toolbar class="wrap">
  <!-- left -->
  <div id="menu-icons">
    <button
      mat-icon-button
      color="primary"
      *ngIf="!isNavigationDisabled"
      (click)="onClickMenuBtn()"
    >
      <mat-icon>{{ (menuOpened$ | async) ? "close" : "menu" }}</mat-icon>
    </button>

    <app-main-menu-list *ngIf="!hideMenu" [theme]="'row'"></app-main-menu-list>
  </div>

  <!-- logo -->
  <a [routerLink]="logoPath" id="logo"><img [src]="logo" alt="EEMO Logo" /></a>

  <!-- right -->
  <div class="right-menu">
    <app-main-menu-right></app-main-menu-right>
  </div>
</mat-toolbar>
